import React from "react";
import { NavLink } from "react-router-dom";
import { Home, Compass, ScanLine, Heart, User } from "lucide-react";

const TABS = [
  { to: "/home", label: "Home", icon: Home, key: "home" },
  { to: "/search", label: "Explore", icon: Compass, key: "explore" },
  { to: "/identify", label: "Identify", icon: ScanLine, key: "identify" },
  { to: "/healing", label: "General Care", icon: Heart, key: "healing" },
  { to: "/profile", label: "Profile", icon: User, key: "profile" },
];

export default function TabBar() {
  return (
    <nav className="tab-bar" data-testid="bottom-tab-bar">
      <ul className="flex justify-around items-stretch px-2 pt-2 pb-2 h-16">
        {TABS.map(({ to, label, icon: Icon, key }) => (
          <li key={key} className="flex-1">
            <NavLink
              to={to}
              data-testid={`tab-${key}`}
              className={({ isActive }) =>
                `flex flex-col items-center justify-center gap-0.5 h-full text-[11px] font-medium transition-colors ${
                  isActive ? "text-[#4CAF50]" : "text-white/40 hover:text-white/70"
                }`
              }
            >
              {({ isActive }) => (
                <>
                  <Icon
                    size={22}
                    strokeWidth={1.6}
                    style={isActive ? { filter: "drop-shadow(0 0 10px rgba(76,175,80,0.7))" } : undefined}
                  />
                  <span style={isActive ? { textShadow: "0 0 8px rgba(76,175,80,0.5)" } : undefined}>
                    {label}
                  </span>
                </>
              )}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
